<template>
  <div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <a :href="baseUrl + 'dashboard/map/punjab'" class="text-decoration-none" v-on:click="alert(1)">
        <div class="info-box bg-warning">
          <!-- <span class="info-box-icon"><i class="far fa-calendar-alt"></i></span> -->
          <div class="info-box-content">
            <span class="info-box-text text-bold">Punjab</span>
            <div class="info-box-number"></div>
             <span class="progress-description">
               CoPC+ sitess: {{ Number(21).toLocaleString() }} <br/>
              Districts covered:  {{ Number(26).toLocaleString() }}
              </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <a :href="baseUrl + 'dashboard/map/sindh'" class="text-decoration-none">
        <div class="info-box bg-success">
          <!-- <span class="info-box-icon"><i class="far fa-handshake"></i></span> -->
          <div class="info-box-content">
            <span class="info-box-text text-bold">Sindh</span>
            <span class="info-box-number"></span>

            <!-- <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: averageContactPercentage + '%' }"
              ></div>
            </div> -->
             <span class="progress-description">
              CoPC+ sites: {{ Number(14).toLocaleString() }} <br/>
              Districts covered:  {{ Number(24).toLocaleString() }}
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>

      <div class="col-md-3 col-sm-6 col-12">
        <a :href="baseUrl + 'dashboard/map/kpk'" class="text-decoration-none">
        <div class="info-box bg-cyan">
          <!-- <span class="info-box-icon"><i class="fas fa-syringe"></i></span> -->
          <div class="info-box-content">
            <span class="info-box-text text-bold">Khyber PukhtoonKhwa</span>
            <span class="info-box-number"> </span>

            <!-- <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: syringePerPersonPercentage + '%' }"
              ></div>
            </div> -->
            <span class="progress-description">
             CoPC+ sites: {{ Number(7).toLocaleString() }} <br/>
              Districts covered:  {{ Number(7).toLocaleString() }}
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <a :href="baseUrl + 'dashboard/map/balochistan'" class="text-decoration-none">
        <div class="info-box bg-danger">
          <!-- <span class="info-box-icon"><i class="fas fa-exchange-alt"></i></span> -->
          <div class="info-box-content">
            <span class="info-box-text text-bold">Balochistan</span>
            <span class="info-box-number"></span>

            <!-- <div class="progress">
              <div
                class="progress-bar"
                v-bind:style="{ width: exchangeRatePercentage + '%' }"
              ></div>
            </div> -->
            <span class="progress-description">
              CoPC+ sites: {{ Number(2).toLocaleString() }} <br/>
              Districts covered:  {{ Number(2).toLocaleString() }}
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      indicators: null,
      distinctContacts: null,
      averageContacts: null,
      exchangeRate: null,
      syringePerPerson: null,
      distinctContactPercentage: 0,
      averageContactPercentage: 0,
      exchangeRatePercentage: 0,
      syringePerPersonPercentage: 0,
      baseUrl : '/'
    };
  },
  methods: {
    async callNsepIndicators() {
      await axios
        .get("byCitiesPWID")
        .then((response) => {
          if (response.status == 200) {
            this.indicators = response.data;
            // console.log(this.indicators[45]);
            this.totalTested = this.indicators[45].DistinctVCCT;
            this.totalReactive = this.indicators[45].Reactive;
            this.totalRegistered = this.indicators[45].totalRegistered;
            this.totalViralLoad = this.indicators[45].totalViralLoad;
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
  },
  mounted() {
    this.callNsepIndicators();
  },
};
</script>

<style lang="scss" scoped></style>
